import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";

//Components
import Loading from "../../../components/Loading/Loading";
import MainCard from "../../../components/MainCard/MainCard";
import { showMessage } from "../../../helpers/message";
import FiltroPrefeitura from "views/Shared/FiltroPrefeitura";

//Api
import dashboard_api from "../../../api/dashboard_api";
import gerador_api from "../../../api/gerador_api";
import transportador_api from "../../../api/transportador_api";
import geradoresCategoria_api from "../../../api/geradoresCategoria_api";

import RelatorioGeradoresSemContratoEPendente from "./RelatorioGeradoresSemContratoEPendente";

function initialStateFiltros() {
  return {
    cnpj: "",
    razao: "",
    transportadorId: "",
    transportadorNome: "",
    situacao: "Todos",
    categoriaId: "",
    dataInicial: "",
    dataFinal: "",
  };
}

export default function GeradoresSemContratoEPendente() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState(initialStateFiltros());
  const [dadosRelatorio, setDadosRelatorio] = useState(null);
  const [prefeitura_Id, setPrefeitura_Id] = useState(null);
  
  const [transportadores, setTransportadores] = useState([]);
  const [categorias, setCategorias] = useState([]);

  useEffect(() => {
    carregarTransportadores();
    carregarCategorias();
  }, []);

  const carregarTransportadores = () => {
    transportador_api.GetAll()
      .then(res => {
        let options = res.data.map(t => ({ value: t.id, label: t.fantasia }));
        options.unshift({ value: "", label: "Todos" });
        setTransportadores(options);
      })
      .catch(e => console.error(e));
  };

  const carregarCategorias = () => {
    geradoresCategoria_api.GetListAtivos()
      .then(res => {
        let options = res.data.map(c => ({ value: c.id, label: c.descricao }));
        options.unshift({ value: "", label: "Todos" });
        setCategorias(options);
      })
      .catch(e => console.error(e));
  };

  const aplicarFiltrosLocais = (listaBase) => {
    const dataDe = filtros.dataInicial ? new Date(filtros.dataInicial) : null;
    const dataAte = filtros.dataFinal ? new Date(filtros.dataFinal) : null;

    return listaBase.filter(item => {
        let passaCnpj = true;
        let passaRazao = true;
        let passaTransp = true;
        let passaCategoria = true;
        let passaData = true;

        if (filtros.cnpj) {
            passaCnpj = item.cpfcnpj && item.cpfcnpj.includes(filtros.cnpj);
        }
        if (filtros.razao) {
            const fantasiaMatch = item.fantasia && item.fantasia.toLowerCase().includes(filtros.razao.toLowerCase());
            const razaoMatch = item.razao && item.razao.toLowerCase().includes(filtros.razao.toLowerCase());
            passaRazao = fantasiaMatch || razaoMatch;
        }
        if (filtros.transportadorNome && filtros.transportadorNome !== "Todos" && filtros.transportadorNome !== "") {
            passaTransp = item.transportador && item.transportador === filtros.transportadorNome;
        }
        if (filtros.categoriaId) {
            passaCategoria = item.categoriaId === filtros.categoriaId;
        }
        if (dataDe || dataAte) {
            const dataCadastro = item.dataHoraCadastro ? new Date(item.dataHoraCadastro) : null;
            passaData = !!dataCadastro &&
                (!dataDe || dataCadastro >= dataDe) &&
                (!dataAte || dataCadastro <= dataAte);
        }

        return passaCnpj && passaRazao && passaTransp && passaCategoria && passaData;
    });
  };

  const handleGerarRelatorio = async () => {
    if (!prefeitura_Id) {
      showMessage("Aviso", "Selecione uma prefeitura", "warning");
      return;
    }

    setLoading(true);
    try {
      let listaGeral = [];

      // Para 'Sem Contrato' ou 'Todos'
      if (filtros.situacao === "Sem Contrato" || filtros.situacao === "Todos") {
        const resSem = await gerador_api.GetListSemContrato({ 
          prefeitura_id: prefeitura_Id, 
          status: "Todos", 
          isRelatorio: true,
          cnpj: filtros.cnpj,
          razao: filtros.razao,
          transportadorId: filtros.transportadorId ? parseInt(filtros.transportadorId) : null
        });
        
        let mappedSem = resSem.data.map(g => ({
          ...g,
          transportador: "-",
          motivoContratoPendente: "-",
          situacaoContrato: "Sem Contrato"
        }));
        listaGeral = [...listaGeral, ...mappedSem];
      }

      // Para 'Contratos Pendentes' ou 'Todos'
      if (filtros.situacao === "Contratos Pendentes" || filtros.situacao === "Todos") {
        const resPend = await dashboard_api.GeradoresContratos(prefeitura_Id, "Contrato Pendente", true);
        let mappedPend = resPend.data.map(g => ({
          ...g,
          situacaoContrato: "Contrato Pendente"
        }));
        listaGeral = [...listaGeral, ...mappedPend];
      }

      const dadosFiltrados = aplicarFiltrosLocais(listaGeral);
      setDadosRelatorio(dadosFiltrados);

    } catch (e) {
      showMessage("Erro", e.message || "Erro ao carregar dados", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlePrefeitura = (value) => {
    setPrefeitura_Id(value);
  };

  if (dadosRelatorio) {
    return (
      <RelatorioGeradoresSemContratoEPendente
        dadosRelatorio={dadosRelatorio}
        btnVoltar={() => {
          setDadosRelatorio(null);
          setFiltros(initialStateFiltros());
        }}
        filtros={filtros}
      />
    );
  }

  return (
    <MainCard btnVoltarInTop={() => navigate(-1)}>
      {loading && <Loading />}
      <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
      <h4>Relatório de Geradores Sem Contrato E Pendente</h4>
      <div className="mt-4">
        <Row>
          <Col md={3}>
            <FormGroup>
              <Label>Situação</Label>
              <Input type="select" value={filtros.situacao} onChange={e => setFiltros({...filtros, situacao: e.target.value})}>
                <option value="Todos">Todos</option>
                <option value="Sem Contrato">Sem Contrato</option>
                <option value="Contratos Pendentes">Contratos Pendentes</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>CNPJ</Label>
              <Input type="text" placeholder="Todos" value={filtros.cnpj} onChange={e => setFiltros({...filtros, cnpj: e.target.value})} />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Razão Social / Fantasia</Label>
              <Input type="text" placeholder="Todos" value={filtros.razao} onChange={e => setFiltros({...filtros, razao: e.target.value})} />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Transportador</Label>
              <Select
                options={transportadores}
                placeholder="Todos"
                value={transportadores.find(t => t.value === filtros.transportadorId) || { value: "", label: "Todos" }}
                onChange={val => setFiltros({
                   ...filtros,
                   transportadorId: val.value,
                   transportadorNome: val.label === "Todos" ? "" : val.label
                })}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Categoria</Label>
              <Select
                options={categorias}
                placeholder="Todos"
                value={categorias.find(c => c.value === filtros.categoriaId) || { value: "", label: "Todos" }}
                onChange={val => setFiltros({ ...filtros, categoriaId: val.value })}
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Data inicial</Label>
              <Input type="date" value={filtros.dataInicial} onChange={e => setFiltros({ ...filtros, dataInicial: e.target.value })} />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <Label>Data final</Label>
              <Input type="date" value={filtros.dataFinal} onChange={e => setFiltros({ ...filtros, dataFinal: e.target.value })} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="text-right mt-3">
             <Button color="primary" onClick={handleGerarRelatorio}>
                Gerar Relatório
             </Button>
          </Col>
        </Row>
      </div>
    </MainCard>
  );
}
